// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-view-loader {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dl-view-loader__text {
  font-size: var(--g-text-body-2-font-size);
  line-height: var(--g-text-body-2-line-height);
  margin-left: 26px;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/ViewLoader/ViewLoader.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAJ;AAEI;EACI,yCAAA;EACA,6CAAA;EACA,iBAAA;AAAR","sourcesContent":[".dl-view-loader {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.dl-view-loader__text {\n  font-size: var(--g-text-body-2-font-size);\n  line-height: var(--g-text-body-2-line-height);\n  margin-left: 26px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
